<template>
  <div v-if="loading" class="loader menu dinline-block vtop fs14 pl35" >
    <div class="loader-inner ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="menu dinline-block vtop fs14 pl35">
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{$params['column'][pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <span>学校首页 > </span>
        <span>{{$params['column'][pid]['name']}} > </span>
        <span>{{$params['column'][pid]['children'][id]['name']}}</span>
      </div>
    </div>
    <div class="cont tleft pt50" v-if="info.title">
      <div class="ncont tc6 fs16 lh20" v-html="info.content">
      </div>
    </div>
    <div v-else>
      {{msg}}
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data(){
    return {
      id:'',
      pid:'',
      perPage:1,
      page:1,
      info:{},
      msg:'加载中……',
      loading:false
    }
  },
  created() {
    this.updateData();
  },
  methods:{
    updateData(){
      this.id = this.$route.query.id
      this.pid = this.$route.query.pid
      this.loading =true
      this.getData();
    },
    getData(){
      var getParam = {}
      var id = this.$params.column[this.pid]['children'][this.id]['params']['id']
      getParam['id'] = id
      this.$request.get('article/detail',getParam,response => {
        if(response.status == 200){
          if(response.data.code != 200){
            this.msg = response.data.message;
            this.info = {};
          }else{
            let res = response.data.data
            this.info = res
          }
        }else{
          this.msg = '请求失败';
        }
        this.loading =false
      },error => {
        console.log(error)
      })
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        if ($n.query.pid !== $o.query.pid || $n.query.id !== $o.query.id) {
          this.loading = true
          this.getData()
        }
        this.info = {};
      }
    }
  },
}
</script>

<style scoped>
.ncont{padding: 10px 35px;line-height: 2.2;}
</style>



// WEBPACK FOOTER //
// src/pages/evn/Content.vue